// extracted by mini-css-extract-plugin
module.exports = {"container":"customers_container__2yP7i","gained":"customers_gained__2WMV8","lost":"customers_lost__3Jd0n","label":"customers_label__3jjvp","value":"customers_value__33fZ4"};